import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import FiltersIasProvision from './FiltersIasProvision';
import { iasProvisionReportRequest } from '../../../requests/employees';
import { downloadFile } from '../../../services/utils';

const IasProvision = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleRequest = params => {
    setIsLoading(true);
    iasProvisionReportRequest({
      dispatch,
      params: {
        ...params,
        active_contracts: true,
        active: true,
        is_dt: false,
        paginate: false,
        sort_column: 'name'
      },
      successCallback: response => {
        downloadFile(response);
        setIsLoading(false);
      },
      callback: () => {
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <FiltersIasProvision formRequest={handleRequest} isLoading={isLoading} />
    </>
  );
};
export default IasProvision;
